import { APP_BASE_HREF } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module';
import { REMOVE_STYLES_ON_COMPONENT_DESTROY } from '@angular/platform-browser';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [AppComponent],
  imports: [CoreModule],
  providers: [
    // Changes address from http://localhost/dist/... to http://localhost/... (see _Layout.cshtml and angular.json)
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: REMOVE_STYLES_ON_COMPONENT_DESTROY, useValue: false },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
